export default {
    'new': {
        delivery: {
            checkbox: 'Delivery',

            form: {
                stockId: 'Warehouse for the formation of an order for delivery',
                deliveryServiceId: 'Delivery service',
                clientName: "Customer's name for delivery",
                clientSurname: "Customer's last name for delivery",
                clientPatronymic: 'Patronymic of the customer for delivery',
            },
        },

        deliveryAddress: {
            deliveryCity: 'Delivery city',
            deliveryIndex: 'Delivery Index',
            deliveryStreet: 'Delivery Street',
            deliveryHouse: 'Delivery House',
            deliveryApartment: 'Delivery Apartment',
            deliveryComment: 'Delivery comment',
            deliveryPicPoint: 'Pic Point',
            deliveryKladrId: 'KLADR',
            lat: 'Latitude (Lat)',
            lon: 'Longitude (Lon)',
        },

        'new': {
            danger:
        '* If changed, the information in the delivery (tariff and delivery service) may change',
            button: 'To create order',
            modalTitle: 'Successful order creation',
            modalText: 'Order created №',

            form: {
                orderSourceTypeId: 'Order source',
                pfm: 'PFM',
                phone: 'Telephone',
                email: 'Email',
                commentClient: "Client's comment",
                payTypeId: '* Payment method',
                customerRequests: "Client's wishes",
                name: "Client's name",
                userAuthorization: 'User status',
                loyaltyCardNumber: 'Loyalty Card',
                lang: 'Language',
                callbackUrl: 'Callback url',
                externalUrl: 'External url',
                currencyId: 'Currency',
            },
        },

        product: {
            title: 'Product',
            buttonPrimary: 'Add a product',
            buttonAddSku: 'Add product by SKU',

            form: {
                sku: 'Item code',
                productName: 'Name',
                productWeight: 'Weight',
                productPrice: 'Price',
                barcode: 'Barcode',
                actualBarcode: 'Реальный баркод',
                skuQuantity: 'Number of commodity items',
                productCommentClient: 'Comment on the position from the client',
                productProperties: 'Parameters',
                vat: 'VAT',
                pic: 'Picture',
            },
        },
    },

    cancel: {
        label: 'Order ID',
        button: 'Cancel',
        modalTitle: 'Successful order cancellation',
        modalText: 'Order № | cancelled',
    },

    payStatus: {
        labelOrderId: 'Order ID',
        labelStatus: 'Payment status',
        labelOperation: 'Type of operation',
        button: 'To change',
        modalTitle: 'Successful change of order payment status',
        modalText: 'Order payment status № | changed',

        statuses: {
            text1: 'Error',
            text2: 'Success',
        },

        operations: {
            approved: 'The operation of withholding (holding) the amount',
            deposited: 'Completion Operation',
            reversed: 'Cancellation operation',
            refunded: 'Return Operation',
            declinedByTimeout: 'The time allowed for payment of the order has expired',
        },
    },

    test: {
        title1: 'To create',
        title2: 'Cancel',
        title3: 'To change',
    },
};